import {Component, Injector, OnInit} from '@angular/core';
import {BaseComponent} from '../../../base.component';
import {MatDialogRef} from '@angular/material/dialog';
import {DataResponse} from '../../../../network/service/data.response';
import {SnackBarUtil} from '../../../../util/snack.bar.util';
import {AddOrUpdateTagOptions} from './options/add-or-update-tag.options';
import {Config} from '../../../../common/config';

@Component({
  selector: 'app-add-or-update-tag',
  standalone: false,
  templateUrl: './add-or-update-tag.component.html',
  styleUrl: './add-or-update-tag.component.scss'
})
export class AddOrUpdateTagComponent extends BaseComponent implements OnInit {
  addOrUpdateTagOptions = new AddOrUpdateTagOptions();
  title?: any;
  imageFiles?: any;
  images?: string[];
  isActive?: any;

  constructor(injector: Injector, private readonly matDialogRef: MatDialogRef<AddOrUpdateTagComponent>) {
    super(injector);
  }

  override ngOnInit() {
    super.ngOnInit();
    this.images = this.addOrUpdateTagOptions.tag.Images;
    if (this.images) {
      this.imageFiles = this.images.map((image: string) => {
        return {
          name: image
        };
      });
    }
    this.title = this.addOrUpdateTagOptions.tag.Title;
    this.isActive = this.addOrUpdateTagOptions.tag.IsActive;
  }

  override loadOnline() {
    super.loadOnline();
  }

  noAction() {
    this.matDialogRef.close();
  }

  upload(index: number, onFinished: any) {
    if (!this.imageFiles || this.imageFiles.length === 0) {
      return onFinished();
    }
    if (index >= this.imageFiles!.length) {
      onFinished();
    } else {
      if (this.imageFiles[index] instanceof File) {
        let formData = new FormData();
        formData.append('File', this.imageFiles[index]);
        this.serviceApi.upload(formData).subscribe((res: DataResponse<any>) => {
          if (res.data) {
            this.images!.push(res.data.dataValues.FileId);
            this.upload(++index, onFinished);
          } else {
            SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
          }
        });
      } else {
        this.images!.push(this.imageFiles[index].name);
        this.upload(++index, onFinished);
      }
    }
  }

  onSubmitClicked() {
    this.images = [];
    this.upload(0, () => {
      (this.addOrUpdateTagOptions.tag.TagId !== undefined ? this.serviceApi.updateTags(this.addOrUpdateTagOptions.tag.TagId, {
        Title: this.title,
        Icon: this.images,
        IsActive: this.isActive,
        DomainId: Config.selectedBusinessId
      }) : this.serviceApi.createTags({
        Title: this.title,
        Icon: this.images,
        IsActive: this.isActive,
        DomainId: Config.selectedBusinessId
      })).subscribe((res: DataResponse<any>) => {
        if (res.success) {
          this.addOrUpdateTagOptions.onInsertOrUpdateFinished();
          this.noAction();
        } else {
          SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
        }
      });
    });
  }
}
